import { setAsyncFormSelector } from "../redux/slice/persist/dropdownSelector";
import { useAppDispatch } from "../redux/store";

interface FilterChangePayload {
  setFieldValue?: (field: string, value: any) => void;
  updatedField: string;
  persistedSelection?: {
    value?: string | null;
    label?: string;
  };
  fieldsToUpdate?: Array<{ field: string; value: any }>;
}

export const useFilterManager = () => {
  const dispatch = useAppDispatch();

  const handleFilterChange = (args: FilterChangePayload) => {
    const { updatedField, setFieldValue, fieldsToUpdate, persistedSelection } =
      args;

    // Update the changed field immediately
    setFieldValue &&
      fieldsToUpdate?.forEach((eachField) => {
        setFieldValue(eachField.field, eachField.value);
      });

    // Immediately clear dependent fields based on the changed field
    switch (updatedField) {
      case "brand_id":
        // Update and Clear the store with new value
        dispatch(
          setAsyncFormSelector({
            ...persistedSelection,
            name: "brand_selector",
          })
        );
        // Clear persisted selections for family
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "family_selector",
          })
        );
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "model_selector",
          })
        );
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "firmware_selector",
          })
        );

        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "template_selector",
          })
        );
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "file_selector",
          })
        );

        break;

      case "family_id":
        dispatch(
          setAsyncFormSelector({
            ...persistedSelection,
            name: "family_selector",
          })
        );
        // Clear any family-dependent fields if needed
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "model_selector",
          })
        );
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "firmware_selector",
          })
        );
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "template_selector",
          })
        );
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "file_selector",
          })
        );

        break;

      case "model_id":
        dispatch(
          setAsyncFormSelector({
            ...persistedSelection,
            name: "model_selector",
          })
        );
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "file_selector",
          })
        );
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "template_selector",
          })
        );

        break;

      case "firmware_id":
        dispatch(
          setAsyncFormSelector({
            ...persistedSelection,
            name: "firmware_selector",
          })
        );
        dispatch(
          setAsyncFormSelector({
            type: "removeValue",
            name: "template_selector",
          })
        );

        break;

      case "template_id":
        dispatch(
          setAsyncFormSelector({
            ...persistedSelection,
            name: "template_selector",
          })
        );

        break;

      // Add more cases for other fields as necessary
    }
  };

  return { handleFilterChange };
};
